import { HttpClient } from '@angular/common/http';
import { SCAMP_API } from 'src/environments/environment';
import { AccountService } from './account.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./account.service";
export class GrupolocalService {
    constructor(http, account) {
        this.http = http;
        this.account = account;
    }
    getAll() {
        return fetch(`${SCAMP_API.accountApiV1}/gruposlocalnivel1`, {
            headers: {
                "Authorization": this.account.composeHeaders().keys["Authorization"]
            }
        }).then(res => res.json());
    }
}
GrupolocalService.ngInjectableDef = i0.defineInjectable({ factory: function GrupolocalService_Factory() { return new GrupolocalService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService)); }, token: GrupolocalService, providedIn: "root" });
